<template>
  <button
    v-on="listeners"
    :tabindex="active ? 0 : 1"
    class="py-2 pr-4 sm:pr-6 inline-flex items-center justify-center block text-base sm:text-lg md:text-xl font-medium tracking-wide rounded-lg leading-normal"
    :class="{
      'focus:shadow-outline focus:outline-none': active,
      'cursor-pointer': active,
      'cursor-not-allowed': !active,
      'pl-4': leftIcon,
      'pl-4 sm:pl-6': !leftIcon,
      [`bg-${color}${shade === 'white' ? '' : '-' + shade} 
        hover:bg-${computedColorHover}${
        computedColorHover === 'white' ? '' : '-' + shadeHover
      }
        text-${textColor}${textShade ? '-' + textShade : ''}`]: true,
      [`hover:text-${textColor}${textShadeHover ? '-' + textShadeHover : ''}`]:
        textShadeHover
    }"
    @click="clicked"
  >
    <!-- TODO: remove clicked, can just pass through listener -->
    <unicon
      v-if="leftIcon"
      :name="leftIcon"
      class="mr-3 w-6 h-6 fill-current"
    />
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    leftIcon: {
      type: String,
      required: false,
      default: null
    },
    color: {
      type: String,
      required: false,
      default: 'red'
    },
    colorHover: {
      type: String,
      required: false,
      default: null
    },
    shade: {
      type: Number,
      required: false,
      default: 700
    },
    shadeHover: {
      type: Number,
      required: false,
      default: 800
    },
    textColor: {
      type: String,
      required: false,
      default: 'white'
    },
    textShade: {
      type: Number,
      required: false,
      default: 0
    },
    textShadeHover: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    computedColorHover() {
      return this.colorHover || this.color
    },
    listeners() {
      const { input, ...listeners } = this.$listeners
      input ? console.log(input) : '' // REMOVE
      return listeners
    }
  },
  methods: {
    clicked() {
      this.$emit('clicked')
    }
  }
}
</script>
